export enum EEndpoints {
  API_ENDPOINT=
    "https://compass.apexdigital.online/secure/api/v2/90539/21010A68F2704355A624B6D0CE776A2D",
  IFRAME_VIEW=
  "https://compass.apexdigital.online/secure/api/v2/90539/overview.aspx?t=959247",
  API_SECURE="https://compass.apexdigital.online/secure/db/90539/preview.aspx?t=857331"
};
